<section class="container py-4">
  <h2 mat-dialog-title>Add {{ data?.title }}</h2>
  <mat-dialog-content>
    <form [formGroup]="uploadForm">
      <ng-container *ngIf="!isLink">
        <div
          class="upload-dropzone"
          [class.dragging]="isDragging"
          (drop)="onDrop($event)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (click)="fileInput.click()"
        >
          <input
            #fileInput
            hidden
            type="file"
            [accept]="allowedFileTypes"
            multiple
            (change)="documentInputChange($event)"
          />
          
          <ng-container *ngIf="selectedFiles.length === 0">
            <img
              src="../../../../../../assets/images/bulkupload_logo.svg"
              alt="Upload Banner"
              class="upload-icon"
            />
            <p translate class="upload-text">Drag & drop files here or click to upload</p>
          </ng-container>
          <ng-container *ngIf="selectedFiles.length > 0">
            <p class="upload-text">
              {{ selectedFiles.length }} file(s) selected.
              <span translate class="link-text">Click here to add</span>
              more files
            </p>
          </ng-container>
        </div>

        <div *ngIf="selectedFiles.length > 0" class="selected-files-list mt-2">
          <div *ngFor="let file of selectedFiles; let i = index" class="selected-file-item">
            <mat-icon>insert_drive_file</mat-icon>
            <span>{{ file.name }}</span>
            <button
              mat-icon-button
              color="warn"
              (click)="removeSelectedFile(i, $event)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isLink" formArrayName="linkList">
        <div *ngFor="let linkGroup of linkList.controls; let i = index; trackBy: trackByLinkIndex" [formGroupName]="i" class="d-flex align-items-start mb-3 link-input-group">
          <mat-form-field appearance="fill" class="flex-grow-1 me-2">
            <mat-label>Document URL #{{ i + 1 }}</mat-label>
            <input
              matInput
              placeholder="e.g. https://www.document.com/file"
              formControlName="link"
              type="url"
            />
            <mat-error *ngIf="linkGroup.get('link')?.invalid && (linkGroup.get('link')?.dirty || linkGroup.get('link')?.touched)">
              <span translate *ngIf="linkGroup.get('link')?.errors?.['required']">Link is required.</span>
              <span translate *ngIf="linkGroup.get('link')?.errors?.['pattern']">
                Please enter a valid URL (must start with http/https).
              </span>
            </mat-error>
          </mat-form-field>

          <button
            mat-icon-button
            color="warn"
            type="button"
            (click)="removeLinkInput(i)"
            *ngIf="linkList.controls.length > 1"
            style="margin-top: 10px"
          >
            <mat-icon>remove_circle</mat-icon>
          </button>
        </div>

        <div class="d-flex justify-content-end">
          <button mat-button type="button" (click)="addLinkInput()">
            <mat-icon>add_circle_outline</mat-icon><span translate> Add Another Link</span>
          </button>
        </div>
      </ng-container>

      <!-- <ng-container
        *ngFor="let question of questions; trackBy: trackByQuestionKey"
      >
        <app-question [question]="question" [form]="uploadForm"></app-question>
      </ng-container> -->
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button
      mat-raised-button
      color="primary"
      (click)="onSubmit()"
      [disabled]="!isLink && selectedFiles.length === 0"
    >
      {{ isLink ? "Submit Links" : "Upload Files" }}
    </button>
    <button
      translate
      mat-button
      type="button"
      (click)="onCancel()"
      class="add-doc cancel_button"
    >
      Cancel
    </button>
  </mat-dialog-actions>
</section>
